module.exports = "/images/dummy-chat.svg?c068c90e7bdb935e9a1db6ba785bbb22";